module.exports = __webpack_public_path__ + "img/shop-photo9.3c682f7b.jpg";